/**
 *
 * A function to change the header on scroll
 *
 *
 */
export function headerInit() {
    window.addEventListener('scroll', headerChange);
}

function headerChange() {
    const scroll = window.scrollY;
    const siteHeader = document.querySelector('.c-site-header');
    const hero = document.querySelector('.c-hero');
    const body = document.body;
    const cookieBanner = document.querySelector('.optanon-alert-box-wrapper');
    
    let changeTrigger = 150;

    // If on homepage with related items, trigger change earlier
    if (
        (hero && (hero.classList.contains('c-home-hero--related-2'))) ||
        body.classList.contains('page-hero-color')
    ) {
        changeTrigger = 25;
    }

    if (scroll >= changeTrigger) {
        siteHeader.classList.add('c-site-header--scroll');
        // Ensures the fixed header shows when the cookie banner is displayed
        if (cookieBanner) {
            body.classList.add('page-scroll');
        }
    } else {
        siteHeader.classList.remove('c-site-header--scroll');
        if (cookieBanner) {
            body.classList.remove('page-scroll');
        }
    }
}